import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SEO_DATA = {
  "/": {
    title:
      "Athees Info Solutions | Construction Management, School ERP & Software Development",
    description:
      "Athees Info Solutions provides Construction Management Software, School ERP Solutions, Mobile App Development, Web Development and IT Staff Augmentation services.",
    keywords:
      "Construction ERP, School ERP, Software Development Company, Mobile App Development, Web Development",
  },

  "/AboutUs": {
    title: "About Us | Athees Info Solutions",
    description:
      "Learn more about Athees Info Solutions and our expertise in enterprise software development and digital transformation.",
    keywords:
      "About Athees Info Solutions, Software Company Madurai",
  },

  "/Brick": {
    title: "Brick | Construction Management Software",
    description:
      "Brick helps simplify construction project management, execution and monitoring.",
    keywords:
      "Construction Management Software, Brick ERP",
  },

  "/ContactUs": {
    title: "Contact Us | Athees Info Solutions",
    description:
      "Reach out to Athees Info Solutions through our Madurai, Bengaluru and Coimbatore offices.",
    keywords:
      "Contact Athees Info Solutions, Madurai Software Company",
  },

  "/SchoolPartnership": {
    title: "School Partnership | Athees Info Solutions",
    description:
      "Partner with Athees Info Solutions to enable digital transformation in education.",
    keywords:
      "School Partnership, Education ERP",
  },
};

export default function Seo() {
  const location = useLocation();

  const seo =
    SEO_DATA[location.pathname] ||
    SEO_DATA["/"];

  const canonical =
    location.pathname === "/"
      ? "https://atheesinfosolutions.com/"
      : `https://atheesinfosolutions.com${location.pathname}`;

  return (
    <Helmet>
      <title>{seo.title}</title>

      <meta
        name="description"
        content={seo.description}
      />

      <meta
        name="keywords"
        content={seo.keywords}
      />

      <link
        rel="canonical"
        href={canonical}
      />

      <meta
        property="og:title"
        content={seo.title}
      />

      <meta
        property="og:description"
        content={seo.description}
      />

      <meta
        property="og:url"
        content={canonical}
      />

      <meta
        property="og:image"
        content="https://atheesinfosolutions.com/Athees256x256.png"
      />

      <meta
        name="twitter:title"
        content={seo.title}
      />

      <meta
        name="twitter:description"
        content={seo.description}
      />

      <meta
        name="twitter:image"
        content="https://atheesinfosolutions.com/Athees256x256.png"
      />

      <meta name="robots" content="index,follow" />

      <meta property="og:type" content="website" />

      <meta
        name="twitter:card"
        content="summary_large_image"
      />
    </Helmet>
  );
}